module.exports = __webpack_public_path__ + "img/partyLogo.a5f58171.png";